<template>
  <div class='body-box marginBox2'>
    <el-row class='plan'></el-row>

    <el-form
      ref='editFormRef'
      :model='editForm'
      label-width='140px'
      :rules='rules'
      v-if='rules'
      style='padding: 20px;background-color: #fff;margin-top: 10px;'
    >
      <el-row>
        <!--球场名称-->
        <el-col :span='8'>
          <el-form-item label='比赛名称' prop='name'>
            <el-input v-model='editForm.name' />
          </el-form-item>
        </el-col>

        <!--希望球场-->
        <el-col :span='8'>
          <el-form-item label='希望球场' prop='courtName'>
            <el-input v-model='editForm.courtName' />
          </el-form-item>
        </el-col>
        <!--报名结束时间-->
        <el-col :span='8'>
          <el-form-item label='报名结束时间' prop='applyEndDate'>
            <el-date-picker style='width: 100%;' v-model='editForm.applyEndDate' type='date'
                            value-format='timestamp'></el-date-picker>
          </el-form-item>
        </el-col>

        <!--开始日-->
        <el-col :span='8'>
          <el-form-item label='开始日' prop='raceDate'>
            <el-date-picker style='width: 100%;' v-model='editForm.raceDate' type='date'
                            value-format='timestamp'></el-date-picker>
          </el-form-item>
        </el-col>



        <!--打球时间-->
        <el-col :span='8'>
          <el-form-item label='打球时间起' prop='raceTime'>
<!--            <el-time-select value-format='HH:mm' v-model='editForm.raceTime' :picker-options="{step: '00:15'}" style='width: 100%;'></el-time-select>-->
            <el-input v-model='editForm.raceTime' />
          </el-form-item>
        </el-col>

        <!--打球时间-->
        <el-col :span='8'>
          <el-form-item label='参加费' prop='joinFee'>
            <el-input v-model='editForm.joinFee' type='number'/>
          </el-form-item>
        </el-col>

        <!--打球时间-->
        <el-col :span='8'>
          <el-form-item label='打球费' prop='fee'>
            <el-input v-model='editForm.fee' type='number'/>
          </el-form-item>
        </el-col>

        <!--预约人-->
        <el-col :span='8'>

          <el-form-item label='预约人' prop='userName'>
            <el-input v-model='editForm.userName' />
          </el-form-item>
        </el-col>

        <!--预约人电话-->
        <el-col :span='8'>
          <el-form-item label='预约人电话' prop='tel'>
            <el-input v-model='editForm.tel' />
          </el-form-item>
        </el-col>

        <!--预约人邮箱-->
        <el-col :span='8'>
          <el-form-item label='预约人邮箱' prop='email'>
            <el-input v-model='editForm.email' />
          </el-form-item>
        </el-col>

        <!--组数-->
        <el-col :span='8'>
          <el-form-item label='组数' prop='num'>
            <el-input v-model='editForm.num' />
          </el-form-item>
        </el-col>

        <!--方式-->
        <el-col :span='8'>
          <el-form-item label='方式' prop='kickOffMode'>
            <el-select v-model='editForm.kickOffMode' clearable placeholder='请选择方式' style='width: 100%'>
              <el-option v-for='item in raceWay' :key='item.id' :label='item.name' :value='item.value'></el-option>
            </el-select>
          </el-form-item>

        </el-col>
        <el-col :span='8'>
          <el-form-item label='排序' prop='sort'>
            <el-input-number v-model="editForm.sort" :step="1" :min='0' :max='999999' step-strictly></el-input-number>
          </el-form-item>
        </el-col>
        <!--轮播图-->
        <el-col :span="24" class="label">
          <el-form-item label="轮播图" prop='carousel'>
            <thumbnail-list v-model="editForm.carousel" :autoCropWidth="800" :autoCropHeight="500"
                            :fixedNumber="[16,10]"></thumbnail-list>
          </el-form-item>
        </el-col>

        <!--备注-->
        <el-col :span='24'>
          <el-form-item label='备注' prop='brief'>
<!--            <el-input type='textarea' v-model='editForm.brief' />-->
            <editor v-model='editForm.brief'></editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="goBackBox">
      <el-button @click='goBack'>返回</el-button>
      <el-button @click='submitModifyOrder'>{{orderId ? '修改比赛' : '添加比赛'}}</el-button>
    </div>
  </div>
</template>

<script>
import { editRacesById,addRaces, getFormConfig } from '@/api/race/raceRaise'
import { raceWay } from '@/js/enum'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList.vue'
import { raiseRules } from '@/js/rules'
import Editor from '@/components/common/editor/editor'
export default {
  name: 'updateGameOrder',
  components: { ThumbnailList,Editor },
  data() {
    return {
      dialogVisible: false,
      name: '',
      editForm: {},
      orderId: '',
      raceWay: raceWay,
      rules: undefined,
    }
  },

  mounted() {
    this.loadFormConfig()
    this.orderId = this.$route.query.id
    this.initialize()
  },

  methods: {
    //初始化
    initialize() {
      if (!this.orderId) {
        return
      }
      let data = localStorage.getItem(this.orderId)
      if (data) {
        this.editForm = JSON.parse(data)
      } else {
        this.$message.info('获取比赛数据失败!')
      }
    },
    loadFormConfig() {
      getFormConfig("game").then(res => {
        let list = res.data
        if (list && list.length > 0) {
          let rules = {}
          for (let rule of list) {
            rules[rule.name] = [{required: rule.required, message: rule.message, trigger: rule.triggerEvent}]
          }
          this.rules = Object.assign(raiseRules, rules)
        } else {
          this.rules = {}
        }
      })
    },
    //返回
    goBack() {
      this.$router.go(-1)
    },

    submitModifyOrder() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        if (this.orderId) {
          editRacesById(this.orderId, this.editForm).then(res => {
            if (res.code === '0') {
              this.$message.success('执行成功!')
              localStorage.removeItem(this.orderId)
              this.goBack()
            }
          })
        } else {
          addRaces(this.editForm).then(res => {
            if (res.code === '0') {
              this.$message.success('执行成功!')
              this.goBack()
            }
          })
        }
      })
    }

  }
}
</script>

<style lang='less' scoped>
.colorStatus {
  color: red;
}
</style>
